import RouterLink from '../../generic/Link/RouterLink';

import styles from '../Login.module.less';
import registerStyles from '../Register.module.less';

export type SignupDisabledStepProps = {
  /** The login page, carrying the entered email and any `next` so the offer to sign in stays useful. */
  loginHref: string;
};

/**
 * Shown in place of the email step when `app:disable_signup_page` is set and the visitor carries no invite:
 * self-serve registration is off, so the only way in is an invite from an administrator.
 */
export const SignupDisabledStep = ({ loginHref }: SignupDisabledStepProps) => (
  <form className={styles.card} onSubmit={event => event.preventDefault()}>
    <h1 className={styles.heading}>Sign up</h1>
    <p role="alert" className={styles.error}>
      User registration has been disabled. Please contact your FOSSA administrator for an invite.
    </p>
    <div className={registerStyles.altAction}>
      Already have an account? <RouterLink to={loginHref}>Sign in</RouterLink>
    </div>
  </form>
);
